<section style="overflow: auto !important; height: auto !important">
  <div class="availability-toolbar">
    <div class="toolbar-left">
      <div
        class="user-select"
        *appVisibleOnly="['update_all_users_availability']"
      >
        <p-select
          [hidden]="!userResources"
          [options]="userResources || []"
          [(ngModel)]="selectedUser"
          [optionLabel]="'title'"
          (onChange)="resourceFilterChange($event, 'USERS')"
          data-cy="user-resource"
        ></p-select>
      </div>

      @if (presenceBooking) {
        <button
          pButton
          type="button"
          class="p-button-outlined p-button-sm"
          (click)="returnToSchedule()"
          data-cy="back-to-schedule"
        >
          &larr; {{ 'availability.back-to-schedule' | translate }}
        </button>
      }
    </div>

    <div class="toolbar-right">
      @if (!isMonthView) {
        <button
          pButton
          type="button"
          class="p-button-sm presence-copy-btn"
          icon="pi pi-copy"
          [pTooltip]="'availability.copy-tooltip' | translate"
          tooltipPosition="bottom"
          (click)="copyWeek()"
          data-cy="copy-availability"
        >
          {{ 'availability.copy' | translate }}
        </button>
      }
      <button
        pButton
        type="button"
        class="p-button-sm"
        icon="pi pi-plus"
        (click)="openBulkDialog('range')"
        data-cy="add-presence"
      >
        {{ 'availability.add-presence' | translate }}
      </button>
    </div>
  </div>

  <full-calendar
    #availabilityProfile
    [options]="calendarOptions"
  ></full-calendar>
</section>
